import Cookies from 'js-cookie'

let db = {
  save(key, value) {
    // localStorage.setItem(key, JSON.stringify(value));
    Cookies.set(key, value);
  },
  saveSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  saveLoaclStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key, defaultValue = {}) {
    if (JSON.parse(localStorage.getItem(key))) {
      return JSON.parse(localStorage.getItem(key));
    } else if (JSON.parse(sessionStorage.getItem(key))) {
      return JSON.parse(sessionStorage.getItem(key));
    } else if (Cookies.get(key)) {
      return Cookies.get(key);
    } else {
      return defaultValue;
    }
  },
  remove(key) {
    localStorage.removeItem(key);
  },
  clearAll() {
    localStorage.clear();
    //清除所有cookie函数
    let date = new Date()
    date.setTime(date.getTime() - 10000)
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
    if (keys) {
      for (var i = keys.length; i--;) {
        if (keys[i] != 'url' && keys[i] != 'userUrl') {
          document.cookie = keys[i] + "=; expire=" + date.toGMTString() + "; path=/"
        }

      }
    }
  },
  clear() {
    localStorage.clear();
    //清除所有cookie函数
    let date = new Date()
    date.setTime(date.getTime() - 10000)
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + "=; expire=" + date.toGMTString() + "; path=/"
      }
    }
  }
}
export default db
